// extracted by mini-css-extract-plugin
module.exports = {"mainMenuItemList":"MainMenuItemList_mainMenuItemList__2HfHZ","mainMenuItem":"MainMenuItemList_mainMenuItem__2pz3T"};